import "core-js";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "./index-override.css";
import "./config.ts";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GroupRouter } from "./main/GroupRouter";
import * as serviceWorker from "./serviceWorker";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retryDelay: 500,
      retry: 2,
    },
  },
});
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <GroupRouter />
  </QueryClientProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
